import { Do } from '../../../../universal';
import { React, _ } from '../../../lib';
import { Alerts } from '../../component-main';
import { reactFlyout } from '../../component-react';
import { FormButton, FormButtonSet } from '../buttons';
import { Combobox } from '../combobox';
import { FileUpload } from '../file-upload';
import { CJSX } from '../meta-types';
import { FormRow } from '../wrappers';
import { getTagComboboxOptions } from './tags';
export const bulkUploadNotes = (rs, filesAll, onResolve) => {
    const existingAttachmentChecksums = _.chain(rs.props.notes)
        .filter(x => !x.Deleted && !x.Archived)
        .map(x => x.Attachment?.Checksum)
        .compact()
        .uniq()
        .value();
    const files = filesAll.filter(x => {
        if (x.Checksum == null) {
            return false;
        }
        return !existingAttachmentChecksums.includes(x.Checksum);
    });
    if (files.length == 0) {
        Alerts.Alert({ msg: 'No new files to upload' });
        onResolve();
        return;
    }
    reactFlyout('Are you sure?', [360, 200], React.createElement(BulkUploadNotesConfirm, { rs: rs, files: files, onResolve: onResolve }), {
        closeCallback: onResolve,
    });
};
export const openBulkUploadNotesFlyout = (rs) => {
    reactFlyout('Bulk Upload Files', [480, 430], React.createElement(BulkUploadNotesUI, { rs: rs }));
};
const BulkUploadNotesUI = (props) => {
    const rs = props.rs;
    const [files, setFiles] = React.useState([]);
    const [tags, setTags] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [isDone, setIsDone] = React.useState(false);
    return (React.createElement("div", { className: "tailwind-wrapper", style: { height: '100%' } },
        React.createElement("p", { className: "pt-2 pb-1 text-left" }, "You can upload multiple files at once. They will be added with the filename as the text. You can also drag files into the notes pane directly without having to open this flyout. Any files that are identical to existing notes uploaded here will be ignored."),
        React.createElement(CJSX, { cond: Boolean(rs.props.tagging) },
            React.createElement(FormRow, { lbl: "Tags", lblWidth: 60 },
                React.createElement(Combobox, { value: tags, onUpdate: v => {
                        setTags(v.map(x => String(x)));
                    }, multiple: true, options: getTagComboboxOptions(rs.props.tagging?.options ?? []) }))),
        React.createElement(FileUpload, { multiple: true, value: files, onUpdate: setFiles, height: 160, ignoreChecksums: getIgnoreChecksums(props.rs) }),
        React.createElement(FormButtonSet, { loading: isLoading, msg: msg, tick: isDone },
            React.createElement(FormButton, { lbl: Do(() => {
                    if (files.length == 1) {
                        return 'Upload 1 file';
                    }
                    return `Upload ${files.length} files`;
                }), disabled: files.length == 0, type: "submit", onClick: () => {
                    setIsLoading(true);
                    setMsg('');
                    actuallyBulkUpload({
                        rs,
                        files: files,
                        tags: tags,
                        onResolve: () => {
                            setMsg('Done');
                            setIsDone(true);
                            setIsLoading(false);
                            props.flyout?.Close();
                        },
                    });
                } }),
            React.createElement(FormButton, { lbl: "Cancel", onClick: () => {
                    props.flyout?.Close();
                } }))));
};
const BulkUploadNotesConfirm = (props) => {
    const rs = props.rs;
    const [tags, setTags] = React.useState(rs.state.filteredTags ?? []);
    const [isLoading, setIsLoading] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [isDone, setIsDone] = React.useState(false);
    const plural = props.files.length > 1 ? 'files' : 'file';
    const confirmationPrompt = rs.props.adding?.bulkUpload?.confirmationPrompt?.(props.files) ??
        `Are you sure you want to upload ${props.files.length} ${plural}?`;
    return (React.createElement(React.Fragment, null,
        confirmationPrompt,
        React.createElement(CJSX, { cond: Boolean(rs.props.tagging) },
            React.createElement(FormRow, { lbl: "Tags", lblWidth: 60 },
                React.createElement(Combobox, { value: tags, onUpdate: v => {
                        setTags(v.map(x => String(x)));
                    }, multiple: true, options: getTagComboboxOptions(rs.props.tagging?.options ?? []) }))),
        React.createElement(FormButtonSet, { loading: isLoading, msg: msg, tick: isDone },
            React.createElement(FormButton, { lbl: "OK", type: "submit", onClick: () => {
                    setIsLoading(true);
                    setMsg('');
                    actuallyBulkUpload({
                        rs,
                        files: props.files,
                        tags: tags,
                        onResolve: () => {
                            setMsg('Done');
                            setIsDone(true);
                            setIsLoading(false);
                            props.onResolve();
                            props.flyout?.Close();
                        },
                    });
                } }),
            React.createElement(FormButton, { lbl: "Cancel", onClick: () => {
                    props.flyout?.Close();
                    props.onResolve();
                } }))));
};
export const getIgnoreChecksums = (rs) => _(rs.props.notes)
    .filter(x => !x.Deleted && !x.Archived)
    .map(x => x.Attachment?.Checksum)
    .compact()
    .uniq()
    .value();
const actuallyBulkUpload = (input) => {
    input.rs.props.adding?.bulkUpload?.onUpload({
        files: input.files,
        tags: input.tags,
    }, () => {
        input.onResolve();
    });
};
//# sourceMappingURL=bulk-upload.js.map